import { z } from 'zod';

export const ssmParameterSecretSchema = z.object({
  type: z.literal('ssm-parameter'),
  parameter: z.string(),
});

export const secretFormSchema = z.discriminatedUnion('type', [
  ssmParameterSecretSchema,
]);